/* eslint-disable react-refresh/only-export-components */
import { IframeStateAction, IframeState } from './types';
import { noop } from 'lodash';
import React, { useContext } from 'react';

export const IframeStateContext = React.createContext<IframeState>({
  iframeWindow: null,
});

const IframeDispatchContext = React.createContext<React.Dispatch<IframeStateAction>>(noop);

export const useIframeDispatch = () => {
  const dispatch = useContext(IframeDispatchContext);
  return dispatch;
};

export default IframeDispatchContext;
